<!-- Hero Section -->
<section class="hero-section">
  <div class="container">
    <div class="hero-content">

      <h1 class="hero-title">Free 11+ Help Club for Year 4</h1>
      <p class="hero-subtitle">Weekly Expert Support to Build Strong 11+ Foundations</p>
      <p class="hero-description">
        Weekly online club designed to strengthen core skills, develop 11+ exam awareness, 
        and nurture a love for learning, all in a supportive and pressure-free environment.
      </p>
      
      <div class="hero-highlights">
        <div class="highlight-item">
          <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
          <span>Every Thursday</span>
        </div>
        <div class="highlight-item">
          <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <span>4:00 PM – 5:00 PM (UK Time)</span>
        </div>
        <div class="highlight-item">
          <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
          </svg>
          <span>Live Online Sessions</span>
        </div>
        <div class="highlight-item highlight-free">
          <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
          </svg>
          <span>Completely Free</span>
        </div>
      </div>

      <button class="cta-button" (click)="openForm()">Join Free Help Club Now</button>
    </div>
  </div>
</section>

<!-- What Is Section -->
<section class="what-is-section">
  <div class="container">
    <h2 class="section-title">What Is the Free 11+ Help Club?</h2>
    <p class="section-text">
      The Free 11+ Help Club is a guided online learning session for Year 4 students preparing 
      for future 11+ exams. It focuses on building strong fundamentals early, so children feel 
      confident and capable as they progress into more advanced preparation.
    </p>
    <div class="motto">
      <span class="motto-icon">💡</span>
      <p class="motto-text">We believe early clarity beats last-minute stress.</p>
    </div>
  </div>
</section>

<!-- Exams Covered Section -->
<section class="exams-section">
  <div class="container">
    <h2 class="section-title">Exams Covered</h2>
    <p class="section-intro">
      Our sessions are aligned with the major UK selective school entrance exams, including:
    </p>
    <div class="exams-grid">
      <div class="exam-card">
        <h3>CSSE</h3>
      </div>
      <div class="exam-card">
        <h3>FSCE</h3>
      </div>
      <div class="exam-card">
        <h3>HBS</h3>
      </div>
      <div class="exam-card">
        <h3>SET</h3>
      </div>


      <div class="exam-card">
        <h3>GL</h3>
      </div>
    </div>
    <p class="exams-footer">
      This ensures broad coverage and exam-relevant practice from the very beginning.
    </p>
  </div>
</section>

<!-- What Your Child Will Get Section -->
<section class="benefits-section">
  <div class="container">
    <h2 class="section-title">What Your Child Will Get</h2>
    <div class="benefits-grid">
      <div class="benefit-card">
        <div class="benefit-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
          </svg>
        </div>
        <h3>Regular Online Classes</h3>
        <p>Engaging, structured weekly lessons led by experienced tutors.</p>
      </div>
      
      <div class="benefit-card">
        <div class="benefit-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
        </div>
        <h3>Practice Sheets & Exam-Style Questions</h3>
        <p>Carefully designed worksheets to reinforce learning and develop accuracy.</p>
      </div>
      
      <div class="benefit-card">
        <div class="benefit-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
          </svg>
        </div>
        <h3>Result Analysis</h3>
        <p>Clear explanations to help students understand mistakes and improve.</p>
      </div>
      
      <div class="benefit-card">
        <div class="benefit-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
          </svg>
        </div>
        <h3>Review & Personalised Feedback</h3>
        <p>Focused feedback so children know exactly how to progress.</p>
      </div>
    </div>
  </div>
</section>

<!-- Why Start in Year 4 Section -->
<section class="why-year4-section">
  <div class="container">
    <h2 class="section-title">Why Start 11+ Preparation in Year 4?</h2>
    <p class="section-intro">Early preparation helps students:</p>
    <div class="reasons-grid">
      <div class="reason-item">
        <div class="reason-number">1</div>
        <p>Build strong Maths, English, and reasoning foundations</p>
      </div>
      <div class="reason-item">
        <div class="reason-number">2</div>
        <p>Develop problem-solving and exam confidence</p>
      </div>
      <div class="reason-item">
        <div class="reason-number">3</div>
        <p>Learn without pressure or burnout</p>
      </div>
      <div class="reason-item">
        <div class="reason-number">4</div>
        <p>Progress steadily and consistently</p>
      </div>
    </div>
    <div class="year4-footer">
      <p>The Free 11+ Help Club is the ideal first step before structured mock tests and advanced courses.</p>
    </div>
  </div>
</section>

<!-- Who Is This For Section -->
<section class="who-section">
  <div class="container">
    <h2 class="section-title">Who Is This Help Club For?</h2>
    <div class="who-grid">
      <div class="who-card">
        <div class="who-icon">👨‍👩‍👧‍👦</div>
        <p>Parents looking for free, high-quality 11+ support</p>
      </div>
      <div class="who-card">
        <div class="who-icon">🎓</div>
        <p>Year 4 students beginning their 11+ journey</p>
      </div>
      <div class="who-card">
        <div class="who-icon">💪</div>
        <p>Children who need clarity, practice, and confidence</p>
      </div>
      <div class="who-card">
        <div class="who-icon">🤝</div>
        <p>Families seeking expert guidance without commitment</p>
      </div>
    </div>
  </div>
</section>

<!-- Why Choose Sehyog Academy Section -->
<section class="why-choose-section">
  <div class="container">
    <h2 class="section-title">Why Choose Sehyog Academy?</h2>
    <div class="choose-grid">
      <div class="choose-card">
        <div class="choose-icon">⭐</div>
        <h3>10K+ Happy Parents</h3>
        <p>Trusted by more than 10,000 successful students across UK</p>
      </div>
      <div class="choose-card">
        <div class="choose-icon">👨‍🏫</div>
        <h3>Experienced Tutors</h3>
        <p>11+ specialist tutors with proven expertise</p>
      </div>
      <div class="choose-card">
        <div class="choose-icon">📈</div>
        <h3>Proven Methods</h3>
        <p>Teaching methods with measurable results</p>
      </div>
      <div class="choose-card">
        <div class="choose-icon">❤️</div>
        <h3>Student-First Approach</h3>
        <p>Supportive environment focused on growth</p>
      </div>
    </div>
    <div class="focus-statement">
      <p>Our focus is not just scores, but long-term academic confidence.</p>
    </div>
  </div>
</section>

<!-- Final CTA Section -->
<section class="final-cta-section">
  <div class="container">
    <div class="final-cta-content">
      <h2>Ready to Give Your Child a Head Start?</h2>
      <p>Join the Free 11+ Help Club and build strong foundations for success</p>
      <button class="cta-button cta-button-large" (click)="openForm()">Enroll Your Child Today – It's Free!</button>
      <p class="cta-subtext">Every Thursday | 4:00 PM – 5:00 PM (UK Time)</p>
    </div>
  </div>
</section>